const BINARY = 'binary';
const LINEAR_SHARE = 'linear-share';
const FACIAL_SHARE = 'facial-share';
const VOLUMETRIC_SHARE = 'volumetric-share';
const PRICE = 'price';
const NONE = 'none';

const SHARE_KPI_TYPES = [LINEAR_SHARE, FACIAL_SHARE, VOLUMETRIC_SHARE];

const isShareKpiType = (teleauditType) => SHARE_KPI_TYPES.includes(teleauditType);

export {
  BINARY,
  LINEAR_SHARE,
  FACIAL_SHARE,
  VOLUMETRIC_SHARE,
  PRICE,
  NONE,
  SHARE_KPI_TYPES,
  isShareKpiType,
};
